export default __webpack_public_path__ + "static/media/casino-go-logo.e7d2c766.svg";